/* ==========================================================================
   CORELLI — behaviour for the Corelli sections
   Three jobs only: scroll reveals, the accordion, and cloning the marquee
   so it loops seamlessly. Everything else is CSS.
   Re-runs itself when a section is added or edited in the theme editor.
   ========================================================================== */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- scroll reveals -------------------------------------------------- */
  function reveals(root) {
    var els = (root || document).querySelectorAll('.crl-rv:not(.is-in)');
    if (!els.length) { return; }
    if (reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- accordion ------------------------------------------------------- */
  function accordions(root) {
    (root || document).querySelectorAll('.crl-acc__h').forEach(function (h) {
      if (h.dataset.crlBound) { return; }
      h.dataset.crlBound = '1';
      h.addEventListener('click', function () {
        var item = h.closest('.crl-acc__i');
        var body = item.querySelector('.crl-acc__b');
        var open = item.classList.toggle('is-open');
        body.style.maxHeight = open ? body.scrollHeight + 'px' : 0;
        h.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      // open by default if the merchant ticked "Open on page load"
      if (h.closest('.crl-acc__i').classList.contains('is-open')) {
        var b = h.closest('.crl-acc__i').querySelector('.crl-acc__b');
        b.style.maxHeight = b.scrollHeight + 'px';
        h.setAttribute('aria-expanded', 'true');
      }
    });
  }

  /* ---- marquee --------------------------------------------------------- */
  function marquees(root) {
    (root || document).querySelectorAll('.crl-marq__t').forEach(function (track) {
      if (track.dataset.crlBound) { return; }
      track.dataset.crlBound = '1';
      var row = track.querySelector('.crl-marq__row');
      if (!row) { return; }
      var clone = row.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      // strip theme-editor hooks from the clone so the editor targets the original
      clone.querySelectorAll('[data-shopify-editor-block]').forEach(function (n) {
        n.removeAttribute('data-shopify-editor-block');
      });
      track.appendChild(clone);
    });
  }

  /* ---- hero video on wide screens only ---------------------------------- */
  function heroVideo(root) {
    if (window.innerWidth < 750) { return; }
    if (navigator.connection && navigator.connection.saveData) { return; }
    (root || document).querySelectorAll('template[data-crl-video]').forEach(function (tpl) {
      var media = tpl.parentNode;
      media.appendChild(tpl.content.cloneNode(true));
      var img = media.querySelector('img');
      if (img) { img.style.display = 'none'; }
      tpl.remove();
    });
  }

  /* ---- ime odabrane varijante uz naziv opcije --------------------------- */
  function variantLabels(root) {
    (root || document).querySelectorAll('.variant-option legend').forEach(function (legend) {
      var field = legend.closest('.variant-option');
      if (!field) { return; }
      var out = legend.querySelector('.crl-vo__value');
      if (!out) {
        out = document.createElement('span');
        out.className = 'crl-vo__value';
        legend.appendChild(out);
      }
      var sync = function () {
        var on = field.querySelector('input:checked');
        out.textContent = on ? on.value : '';
      };
      if (!field.dataset.crlBound) {
        field.dataset.crlBound = '1';
        field.addEventListener('change', sync);
      }
      sync();
    });
  }

  /* ---- tabovi: nav se gradi iz naslova akordeona ------------------------ */
  function tabs(root) {
    (root || document).querySelectorAll('.crl-tabs').forEach(function (box) {
      if (box.dataset.crlTabs) { return; }
      box.dataset.crlTabs = '1';
      var items = [].slice.call(box.querySelectorAll('.crl-acc__i'));
      if (items.length < 2) { return; }
      var nav = document.createElement('div');
      nav.className = 'crl-tabs__nav';
      items.forEach(function (item, i) {
        var head = item.querySelector('.crl-acc__h');
        var label = head ? head.textContent.trim() : 'Detalji';
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = label;
        b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        b.addEventListener('click', function () {
          nav.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-selected', 'false'); });
          b.setAttribute('aria-selected', 'true');
          items.forEach(function (x) { x.removeAttribute('data-on'); });
          item.setAttribute('data-on', '');
        });
        nav.appendChild(b);
        if (i === 0) { item.setAttribute('data-on', ''); }
        var body = item.querySelector('.crl-acc__b');
        if (body) { body.style.maxHeight = 'none'; }
      });
      box.insertBefore(nav, box.firstChild);
    });
  }

  /* ---- sticky traka: kupovina uvijek nadohvat ---------------------------- */
  function buyBar() {
    var payBtn = document.querySelector('.shopify-payment-button__button');
    if (!payBtn || document.querySelector('.crl-buybar')) { return; }

    var titleEl = document.querySelector('.product-details h1, h1');
    var priceEl = document.querySelector('.crl-price');
    var imgEl = document.querySelector('.product-media img, .media-gallery img, img');

    var bar = document.createElement('div');
    bar.className = 'crl-buybar';
    bar.innerHTML =
      '<img alt="">' +
      '<div class="crl-buybar__m"><b></b><span></span></div>' +
      '<button type="button"></button>';
    document.body.appendChild(bar);

    var img = bar.querySelector('img');
    var name = bar.querySelector('b');
    var meta = bar.querySelector('span');
    var cta = bar.querySelector('button');

    /* KUPI's "added to cart" feedback: the real Add to Cart button already plays an elaborate
       checkmark-burst animation (see .add-to-cart-button[data-added] in base.css), but that
       markup and CSS are specific to that button's own DOM structure — KUPI is either Shopify's
       own web component (can't safely touch its internals) or this bar's plain custom button.
       Safe equivalent: briefly swap KUPI's own text for the same checkmark shape the real
       button settles on (ring faded out, tick drawn — see .add-to-cart-button[data-added] .tick
       /.ring in base.css), with its own small pop-in animation (see .crl-kupi-check in
       corelli.css). The wrapper forces its own centering (width: 100%, flex, centered) instead
       of relying on the host button's text-align, since that differs between the native Shopify
       button and this bar's plain <button>. */
    var CHECKMARK_SVG = '<span class="crl-kupi-check">' +
      '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M9 12.75L11.25 15L15 9.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg></span>';

    function flashAdded(btn) {
      if (!btn) return;
      if (btn._crlAddedTimeout) { clearTimeout(btn._crlAddedTimeout); }
      btn.innerHTML = CHECKMARK_SVG;
      btn._crlAddedTimeout = setTimeout(function () {
        btn.textContent = 'KUPI';
        btn._crlAddedTimeout = null;
      }, 1500);
    }

    function sync() {
      var chosen = document.querySelector('.variant-option input:checked');
      var t = (titleEl ? titleEl.textContent.trim() : '');
      name.textContent = chosen ? t + ' — ' + chosen.value : t;
      if (priceEl) {
        var main = priceEl.querySelector('.crl-price__main');
        var alt = priceEl.querySelector('.crl-price__alt');
        meta.textContent = [main && main.textContent, alt && alt.textContent].filter(Boolean).join(' · ');
      }
      var big = document.querySelector('.media-gallery img, .product-media img');
      if (big && big.currentSrc) { img.src = big.currentSrc; }
      else if (imgEl && imgEl.currentSrc) { img.src = imgEl.currentSrc; }
      /* Skip while a checkmark flash is in progress (see flashAdded) so a 'change' event
         firing mid-flash (e.g. quantity tweaked right after adding to cart) doesn't cut it
         short by immediately overwriting the icon back to plain text. */
      if (!payBtn._crlAddedTimeout) { payBtn.textContent = 'KUPI'; }
      if (!cta._crlAddedTimeout) { cta.textContent = 'KUPI'; }
    }
    sync();
    document.addEventListener('change', sync);
    window.addEventListener('pageshow', function () { cta.disabled = false; });

    /* Hide this floating bar entirely for pre-order variants: KUPI itself is hidden then (see
       assets/corelli.css), and this bar just duplicates it. The pre-order message is inserted
       asynchronously (after the variant-select fetch resolves), well after any 'change' event
       has already fired — so react to its actual appearance via MutationObserver instead of
       trying to catch it synchronously in sync(). Scoped to the product form buttons (not
       document.body, and specifically NOT including `bar` itself) so this never re-triggers
       from the bar's own updates. */
    function updateBarVisibility() {
      bar.style.display = document.querySelector('.pre-order-message') ? 'none' : '';
    }
    updateBarVisibility();
    var formButtons = document.querySelector('.product-form-buttons');
    if (formButtons) {
      new MutationObserver(updateBarVisibility).observe(formButtons, { childList: true, subtree: true });
    }
    var anchor = payBtn.closest('.accelerated-checkout-block') || payBtn;
cta.addEventListener('click', function () {
      var form = document.querySelector('form[action*="/cart/add"]');
      var variant = form && form.querySelector('[name="id"]');

      if (!form || !variant || !variant.value) {
        var live = document.querySelector('.shopify-payment-button__button');
        if (live) { live.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        return;
      }

      /* Reuse the theme's own Add to Cart flow — it opens the side cart drawer, handles
         quantity rules and errors, and plays the button animation — instead of a separate
         fetch()+redirect to /cart below. That real button stays in the DOM even when CSS
         hides it (non-pre-order variants show the dynamic checkout button instead), and a
         programmatic click() still triggers its real form submission correctly. */
      var realAddToCartButton = form.querySelector('[ref="addToCartButton"]');
      if (realAddToCartButton) {
        if (realAddToCartButton.disabled) {
          realAddToCartButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        cta.disabled = true;
        setTimeout(function () { cta.disabled = false; }, 1000);
        flashAdded(payBtn);
        flashAdded(cta);
        realAddToCartButton.click();
        return;
      }

      cta.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (response) {
          if (!response.ok) { throw new Error('Cart add failed'); }
          window.location.assign('/cart');
        })
        .catch(function () {
          cta.disabled = false;
          form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
    });




    document.addEventListener('click', function (event) {
      var nativeBuy = event.target.closest && event.target.closest('.shopify-payment-button__button');
      if (!nativeBuy) { return; }
      event.preventDefault();
      event.stopImmediatePropagation();
      cta.disabled = false;
      cta.click();
    }, true);




    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { bar.removeAttribute('data-on'); }
        else { bar.setAttribute('data-on', ''); }
      });
    }, { rootMargin: '-8px' }).observe(anchor);
  }

  function init(root) {
    reveals(root); accordions(root); marquees(root); heroVideo(root);
    variantLabels(root); tabs(root); buyBar();
  }

  if (document.readyState !== 'loading') { init(document); }
  else { document.addEventListener('DOMContentLoaded', function () { init(document); }); }

  // Theme editor: re-init when a section is added, moved or its settings change
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest && e.target.closest('.crl-acc__i');
    if (item && !item.classList.contains('is-open')) { item.querySelector('.crl-acc__h').click(); }
  });
}());
